import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import useSubscriptionStatus from 'app/hooks/useSubscriptionStatus';
import { buildRegularizationRoute } from 'app/helpers/subscriptionRegularizationRoutes';
import type { PricingCatalogErrorCode } from 'app/services/pricingCatalog';

type UseCatalogUnresolvableRedirectParams = {
  error: PricingCatalogErrorCode | null;
  isOpen: boolean;
  onClose: () => void;
};

// Redireciona pro subsistema de regularização já existente (openCardRegularization/openCompletePayment
// em `/plano-e-pagamento`) em vez de abrir o modal de planos com o status irresolvível. Guardado por
// `isOpen`: ExplorePlansModal/ComparePlansModal montam (e a query do catálogo roda) independentemente
// de `isOpen` sempre que usePlanExploration monta a Sidebar — sem esse guard, todo usuário nesse status
// seria redirecionado ao carregar qualquer página, não só ao tentar abrir o modal de planos.
export const useCatalogUnresolvableRedirect = ({
  error,
  isOpen,
  onClose,
}: UseCatalogUnresolvableRedirectParams): void => {
  const history = useHistory();
  const { isCreditCardSubscription } = useSubscriptionStatus();

  useEffect(() => {
    if (!isOpen || error !== 'SUBSCRIPTION_STATUS_UNRESOLVABLE') {
      return;
    }

    onClose();
    history.push(buildRegularizationRoute({ isCreditCardSubscription }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, error]);
};
